import { render, staticRenderFns } from "./WebsiteDnsResult.vue?vue&type=template&id=632b2d4e&"
import script from "./WebsiteDnsResult.vue?vue&type=script&lang=ts&"
export * from "./WebsiteDnsResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports